import React, { createContext, useContext, useState } from 'react';

// Create the context
const EmailConfigContext = createContext();

// Default schedule configuration
const defaultSchedule = {
  daysOfWeek: [],
  timesPerDay: "",
  startTime: '',
  endTime: '',
  timezone: ''
};

// Default email parameters
const defaultParameters = {
  userEmail: "",
  dynamicFolders: {},
  keywords: {
    decline: [],
    forward: []
  },
  exclusions: { list: [] },
  tones: {},
  aiFeatures: {}
};

// Provider component
export const EmailConfigProvider = ({ children }) => {
  const [schedule, setSchedule] = useState(defaultSchedule);
  const [parameters, setParameters] = useState(defaultParameters);

  // Update schedule configuration
  const updateSchedule = (newSchedule) => {
    setSchedule(prev => ({ ...prev, ...newSchedule }));
  };

  // Update email parameters
  const updateParameters = (newParameters) => {
    setParameters(prev => ({ ...prev, ...newParameters }));
  };

  // Reset to defaults
  const resetToDefaults = () => {
    setSchedule(defaultSchedule);
    setParameters(defaultParameters);
  };

  // Context value
  const contextValue = {
    schedule,
    parameters,
    updateSchedule,
    updateParameters,
    resetToDefaults
  };

  return (
    <EmailConfigContext.Provider value={contextValue}>
      {children}
    </EmailConfigContext.Provider>
  );
};

// Custom hook to use the context
export const useEmailConfig = () => {
  const context = useContext(EmailConfigContext);
  if (!context) {
    throw new Error('useEmailConfig must be used within an EmailConfigProvider');
  }
  return context;
};
